import { Link } from "react-router-dom";

interface CtaBandProps {
  title?: string;
  description?: string;
  buttonLabel?: string;
}

export default function CtaBand({
  title = "Have a Question About Our Services?",
  description = "Contact Florida Family Clinic to request more information about our services and clinic availability.",
  buttonLabel = "Contact the Clinic",
}: CtaBandProps) {
  return (
    <section className="w-full px-4 md:px-6 pb-16 md:pb-24">
      <div className="max-w-content mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-primary-950 px-6 py-12 md:px-14 md:py-16">
          <div className="absolute -top-16 -right-10 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl" />
          <div className="absolute -bottom-20 left-10 w-72 h-72 rounded-full bg-accent-500/10 blur-3xl" />
          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl md:text-3xl font-bold leading-tight text-background-50">
                {title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-secondary-200">{description}</p>
            </div>
            <div className="shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-chat-1-line" />
                {buttonLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}